const list = [
  // English
  "anal",
  "ass",
  "asshole",
  "bitch",
  "bullshit",
  "butt",
  "cock",
  "cunt",
  "dick",
  "damn",
  "faggot",
  "fuck",
  "fucker",
  "motherfucker",
  "pussy",
  "shit",
  "whore",

  // Vietnamese
  "mày",
  "tao",
  "buồi",
  "bú buồi",
  "bú cu",
  "chịch",
  "con bà mày",
  "con bán hoa",
  "thằng chó này",
  "con chó chết",
  "con chó đẻ",
  "con cặc",
  "con mẹ mày",
  "con đĩ",
  "cặc",
  "cứt",
  "kệ mẹ mày",
  "kệ mẹ tao",
  "lồn",
  "lìn",
  "lỗ đít",
  "mẹ đồ ngu",
  "mẹ bố mày",
  "mẹ bố thằng",
  "phịch",
  "nện nhau",
  "thằng chó chết",
  "thằng chó đẻ",
  "vãi cứt",
  "vãi lồn",
  "vãi đái",
  "ăn cu",
  "ăn cứt",
  "ăn máu lồn",
  "đái",
  "đcm",
  "đéo",
  "địt",
  "đcmm",
  "đm",
  "đmm",
  "đù má",
  "đĩ",
  "đĩ mẹ mày",
  "địt",
  "địt bà",
  "địt bố",
  "địt cha",
  "địt con mẹ mày",
  "địt con đĩ mẹ mày",
  "địt cái lồn mẹ mày",
  "địt cả lũ nhà mày",
  "địt cụ",
  "địt cụ mày",
  "địt mẹ",
  "địt mẹ mày",
  "địt mẹ nhà mày",
  "đồ chó chết",
  "đồ chó đẻ",
  "đụ",
  "đụ má",
  "đụ má mày",
  "đụ má mày con chó",
  "đụ má mày con đĩ",
  "đụ mẹ mày",
  "vếu"
];

const censorWords = str =>
  str
    .split(" ")
    .map(word => (list.includes(word) ? "*".repeat(word.length) : word))
    .join(" ");

export default {
  list,
  censorWords
};
